module.exports = __webpack_public_path__ + "img/menu01.ab0a0bbb.svg";